export const SNACKBAR_NOTIFICATION_DEFAULT_DESKTOP_BOTTOM_OFFSET_PX = 12;
export const SNACKBAR_NOTIFICATION_DEFAULT_MOBILE_BOTTOM_OFFSET_PX = 50;
export const SNACKBAR_NOTIFICATION_STICKY_DESKTOP_TOP_OFFSET_PX = 64;
export const SNACKBAR_NOTIFICATION_STICKY_MOBILE_TOP_OFFSET_PX = 84;
